import { createFileRoute } from '@tanstack/react-router'
import { requireSection } from '../../../features/settings/guards'
import { TasksSection } from '../../../features/settings/tasks-section'

export const Route = createFileRoute('/_app/settings/tasks')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'tasks'),
  component: TasksSection,
})
